import type { ScratchcardDetails } from '../types';

/**
 * Resolves the mapping path for a scratchcard based on the game code or title.
 * @param scratchcards - The list of scratchcards to search through.
 * @param scratchcardId - The id of the scratchcard to resolve the mapping path for.
 * @returns The mapping path for the scratchcard, or undefined if no mapping path is found.
 */
function resolveScratchcardMappingPath(scratchcards: ScratchcardDetails[], scratchcardId: string): string | undefined {
  const matchByGameCode = scratchcards.find(sc => sc.gameCode === scratchcardId);
  if (matchByGameCode) {
    return matchByGameCode.mappingPath;
  }

  const matchByTitle = scratchcards.find(sc => sc.title === scratchcardId);
  if (matchByTitle) {
    return matchByTitle.mappingPath;
  }

  return undefined;
}

export { resolveScratchcardMappingPath };
